/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-types */

import { toast } from 'react-toastify';
import axios from './axiosConfig';
import { logOutInit, logOutSuccess } from '../../../store/slices/authSlice';
import { removeToken } from '../../utils/utils';
import { AppThunk, DISPATCH } from '../../../store';
// import { logOut, logOutJWT } from '../../components/shared.service';

export const METHOD = {
	POST: 'post',
	GET: 'get',
	PUT: 'put',
	DELETE: 'delete',
	PATCH: 'patch'
};

// const dispatch = () => useAppDispatch();

export const apiCall = (
	endpoint: string,
	params = {},
	onSuccess: Function,
	onFailure: Function,
	method = METHOD.GET,
	DynamicConfig: any
) => {
	const request = (): Promise<any> => {
		switch (method) {
			case METHOD.POST:
				return axios.post(endpoint, params, { ...DynamicConfig });
			case METHOD.GET:
				return axios.get(endpoint, { ...DynamicConfig });
			case METHOD.DELETE:
				return axios.delete(endpoint, { ...DynamicConfig });
			case METHOD.PUT:
				return axios.put(endpoint, params, { ...DynamicConfig });
			case METHOD.PATCH:
				return axios.patch(endpoint, params, { ...DynamicConfig });
		}
		return new Promise((resolve, reject) => resolve({}));
	};

	const req = request();

	req
		.then(response => {
			if (
				(response.status === 200 ||
					response.status === 201 ||
					response.status === 204 ||
					response.data) &&
				response.data !== ''
			) {
				if (DynamicConfig.showToast && response.data.message) {
					toast.success(response.data.message);
				}
				onSuccess(response.data);
			} else if (response.status === 200 || response.status === 204) {
				onSuccess('success');
			} else {
				onFailure('Something went wrong');
			}
		})
		.catch(error => {
			if (error && error.response) {
				if (DynamicConfig.showToast && error.response.data.message) {
					if (error.response.status == 500) {
						toast.error('Server Error');
					} else {
						toast.error(error.response.data.message);
					}
				}

				switch (error.response.status) {
					case 401:
						onFailure(
							error.response.data && typeof error.response.data.detail
								? error.response.data.detail
								: 'Session expired'
						);

						break;

					// case 404:
					// 	window.location.replace('/pageNotFound');
					// 	break;

					default:
						onFailure(error.response.data ? error.response.data : 'Something went wrong');
						break;
				}
			} else onFailure && onFailure('Something went wrong');
		});
};
